module.exports = __webpack_public_path__ + "media/images/front/premium_lp/point02/th_05-06ef6d5b1fcb1eac28babbb7f4824d72.jpg";